import api from "@/lib/api";

export async function fetchLinkedAccounts() {
  const { data } = await api.get("/auth/linked-accounts");
  return Array.isArray(data) ? data : [];
}

export async function linkAccounts(partnerUserId, verificationId = null) {
  const payload = { partner_user_id: partnerUserId };
  if (verificationId) payload.verification_id = verificationId;
  const { data } = await api.post("/auth/linked-accounts/link", payload);
  return data;
}

export async function checkLinkEmail(email) {
  const { data } = await api.post("/auth/linked-accounts/check-email", { email });
  return data;
}

export async function requestLinkVerificationCode(email) {
  const { data } = await api.post("/auth/linked-accounts/verify-email/request-code", { email });
  return data;
}

export async function verifyLinkCode(verificationId, code) {
  const { data } = await api.post("/auth/linked-accounts/verify-email/confirm", {
    verification_id: verificationId,
    code,
  });
  return data;
}

/** Fusionne comptes serveur (liés) + jetons locaux pour l'UI. */
export function mergeLinkedAndLocalAccounts(linkedAccounts, savedAccounts, activeUser) {
  const byId = new Map();

  (linkedAccounts || []).forEach((account) => {
    byId.set(account.user_id, {
      ...account,
      has_local_token: false,
      is_active: account.user_id === activeUser?.user_id,
    });
  });

  (savedAccounts || []).forEach((account) => {
    const existing = byId.get(account.user_id) || {};
    byId.set(account.user_id, {
      ...existing,
      ...account,
      has_local_token: true,
      is_active: account.user_id === activeUser?.user_id,
    });
  });

  if (activeUser && !byId.has(activeUser.user_id)) {
    byId.set(activeUser.user_id, {
      ...activeUser,
      has_local_token: true,
      is_active: true,
    });
  }

  return Array.from(byId.values()).sort((a, b) => {
    if (a.is_active) return -1;
    if (b.is_active) return 1;
    return (a.name || "").localeCompare(b.name || "");
  });
}